export type SignUpRequest = {
    userEmail: string;
    userFullName: string;
    userPassword: string;
    confirmPassword: string;
};

export const SignUpRequestInit: SignUpRequest = {
    userEmail: "",
    userFullName: "",
    userPassword: "",
    confirmPassword: "",
};
